import { isVimeoVideoUrl } from './vimeo';
import { isYoutubeVideoUrl } from './youtube';

export function getVideoSourceTypeFromUrl(
  url: string,
): 'youtube' | 'vimeo' | 'raw' {
  if (isVimeoVideoUrl(url)) return 'vimeo';
  if (isYoutubeVideoUrl(url)) return 'youtube';

  return 'raw';
}
